export default __webpack_public_path__ + "static/media/flag-nl.22811c6c.svg";